<bcb-generic-label [question]="question"></bcb-generic-label>
<mat-form-field appearance="outline">
	<mat-icon matSuffix>percentage</mat-icon>
	<input matInput [formControl]="control" (blur)="onTouched()" />
	<mat-hint align="end">{{ remainingPercentage }}% remaining</mat-hint>
	<mat-error *ngIf="control?.invalid">{{ errorMessage }}</mat-error>
</mat-form-field>
